import React, { useState, useEffect } from "react";
import Table, { defaultFieldValue } from "../../../../Common/Table";
import { getLocalTimeFromEpoch } from "../../../../../utils";
const AllKeysTable = ({
  data = [],
  fieldValue = defaultFieldValue,
  priorityHeaders = [],
}) => {
  const [headers, setHeaders] = useState([]);

  function getItems() {
    return data || [];
  }

  useEffect(() => {
    const fetchHeaders = () => {
      const allHeaders = getItems().reduce((allKeys, item) => {
        const itemKeys = Object.keys(item);
        itemKeys.forEach((key) => {
          if (!allKeys.includes(key)) {
            allKeys.push(key);
          }
        });
        return allKeys;
      }, []);
      // Reorder the headers based on the priorityHeaders array. for reset of keys, ordering is random
      const orderedHeaders = [
        ...priorityHeaders.filter((header) => allHeaders.includes(header)),
        ...allHeaders.filter((header) => !priorityHeaders.includes(header)),
      ];

      setHeaders(orderedHeaders);
    };

    fetchHeaders();
  }, [data]);

  return (
    <Table
      blankStateComponent={null}
      getFieldValue={fieldValue}
      fields={headers.map((column) => {
        return {
          heading: column,
          key: column,
        };
      })}
      list={getItems()}
      wrapContents={true}
    />
  );
};

export default AllKeysTable;
